import React from "react";

import Card from "antd/es/card";
import cn from "classnames";
import { useIntl } from "react-intl";

import Stage from "@mapmycustomers/shared/types/entity/deals/Stage";

import styles from "./StageCard.module.scss";

interface Props {
  onClick: (stage: Stage | undefined) => void;
  selected?: boolean;
  stage: Stage | undefined;
  title?: string;
}

const StageCard: React.FC<Props> = ({ onClick, selected, stage, title }) => {
  const intl = useIntl();
  return (
    <Card
      className={cn(styles.container, { [styles.selected]: selected })}
      onClick={() => onClick && onClick(stage)}
    >
      <div className={styles.content}>
        <span className={styles.title}>{stage?.name ?? title}</span>
        {stage !== undefined && (
          <span className={styles.weight}>
            {intl.formatNumber(stage.weight, {
              maximumFractionDigits: 2,
              style: "percent",
            })}
          </span>
        )}
      </div>
    </Card>
  );
};

export default StageCard;
